export default "__VITE_ASSET__CH2cmLpx__"